var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtcOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 17,
    viewBox: "0 0 25 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.73706 1H5.73706L8.41706 14.39C8.50851 14.8504 8.75897 15.264 9.12461 15.5583C9.49024 15.8526 9.94776 16.009 10.4171 16H20.1371C20.6064 16.009 21.0639 15.8526 21.4295 15.5583C21.7952 15.264 22.0456 14.8504 22.1371 14.39L23.7371 6H6.73706",
    stroke: "#373F41",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtcOrder);
export default __webpack_public_path__ + "static/media/otc-order.597f0cb3c35a7a44955bbb3ccf86ec69.svg";
export { ForwardRef as ReactComponent };